import { render, staticRenderFns } from "./FeatureCardVehicle.vue?vue&type=template&id=e839feea&scoped=true&"
import script from "./FeatureCardVehicle.vue?vue&type=script&lang=js&"
export * from "./FeatureCardVehicle.vue?vue&type=script&lang=js&"
import style0 from "./FeatureCardVehicle.vue?vue&type=style&index=0&id=e839feea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e839feea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow,VSpacer})
